// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";


// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";
import Ticker from "../../GraphicElements/Ticker";


interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = true // Default a true se non specificato
}) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    // Transizione syle text wrapper
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const timeOut = setTimeout(() => setVisible(true), 1000);
        return () => clearTimeout(timeOut);
    }, [])

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner bg-overlay-black-20">
            <div className="container-fluid">
                <div className={`text-wrapper ${visible ? "visible" : ""}`}>
                    <h1 className="sub-title" dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }} />
                    <p className="sub-title" dangerouslySetInnerHTML={{ __html: t('homePage.hero.subTitle') as string }} />
                </div>
            </div>
            {showSearchForm && <PropertySearchField searchData={{}} />}
            <Ticker />
        </section>
    );
};

export default SubHeaderHome;